// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconOutlineHome = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 16 16',
      fill: 'none',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8 12.5C7.72667 12.5 7.5 12.2733 7.5 12V10C7.5 9.72667 7.72667 9.5 8 9.5C8.27334 9.5 8.5 9.72667 8.5 10V12C8.5 12.2733 8.27334 12.5 8 12.5Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.7333 15.04H4.26665C3.05332 15.04 1.94664 14.1067 1.74664 12.9133L0.859974 7.59999C0.713307 6.77332 1.11997 5.71331 1.77998 5.18665L6.4 1.48663C7.29333 0.766629 8.7 0.773295 9.60001 1.4933L14.22 5.18665C14.8734 5.71331 15.2734 6.77332 15.14 7.59999L14.2534 12.9067C14.0534 14.0867 12.92 15.04 11.7333 15.04ZM7.99333 1.9533C7.64 1.9533 7.28667 2.05997 7.02666 2.26663L2.40665 5.97332C2.03331 6.27332 1.76664 6.96665 1.84664 7.43999L2.73331 12.7467C2.85331 13.4467 3.55332 14.04 4.26665 14.04H11.7333C12.4467 14.04 13.1467 13.4467 13.2667 12.74L14.1534 7.43332C14.2267 6.96665 13.96 6.25998 13.5934 5.96665L8.97334 2.2733C8.70667 2.05997 8.34667 1.9533 7.99333 1.9533Z',
      fill: 'currentColor',
    }),
  );

export { IconOutlineHome };
